/**
 * Weather-related functionality including lightning tracking
 */

import {
  getCheckTimes,
  getChart,
  getTempUnit,
  setTempUnit,
  getCurrentTempF,
  getCurrentTempC,
} from './state.js';
import { formatRelativeTime } from '../utils/time.js';

let lightningCheck = null;

/**
 * Process lightning strike data and update UI
 * @param {number} d - Distance in miles
 * @param {number} t - Unix timestamp
 */
export function processLightning(d, t) {
  if (typeof lightningCheck !== 'undefined' && lightningCheck !== null) {
    clearTimeout(lightningCheck);
  }

  const e = new Date(t * 1000);
  const n = new Date();

  const timesince = (n - e) / 1000;

  // Update lightning indicator color based on time and distance
  if (timesince < 60 * 15 && d <= 10) {
    jQuery('#chart-lightning').css({ fill: '#fc0303' }); // Red: Recent and close
  } else if (timesince < 60 * 15) {
    jQuery('#chart-lightning').css({ fill: '#ffaa00' }); // Orange: Recent but far
  } else if (timesince < 60 * 30) {
    jQuery('#chart-lightning').css({ fill: '#f2ef44' }); // Yellow: Moderate
  } else {
    jQuery('#chart-lightning').css({ fill: '#00a60b' }); // Green: Old
  }

  jQuery('#lightning-alert-distance').text(d);
  jQuery('#lightning-alert-time').attr('datetime', e.toISOString());
  jQuery('#lightning-alert-time').text(formatRelativeTime(e));

  const checkTimes = getCheckTimes();
  lightningCheck = setTimeout(processLightning, checkTimes['Lightning'], d, t);
}

/**
 * Start temperature rotation display
 */
export function startTemperatureRotation() {
  setInterval(() => {
    jQuery('.temp-f').toggle();
    jQuery('.temp-c').toggle();

    // Toggle the temperature unit and update gauge
    const newUnit = getTempUnit() === 'F' ? 'C' : 'F';
    setTempUnit(newUnit);
    updateTemperatureGauge(newUnit);
  }, 5000);
}

/**
 * Update temperature gauge to show F or C value (label only, not gauge position)
 * @param {string} unit - 'F' or 'C'
 */
function updateTemperatureGauge(unit) {
  const chartDP = getChart('dp');
  if (!chartDP) {
    return;
  }

  const tempF = getCurrentTempF();
  const tempC = getCurrentTempC();
  if (tempF === null || tempC === null) {
    return;
  }

  const tempValue = unit === 'F' ? tempF : tempC;
  const unitLabel = unit === 'F' ? '°F' : '°C';

  // Update only the display label, not the gauge bar position
  const tempSeries = chartDP.series[0];
  if (tempSeries) {
    tempSeries.update({
      dataLabels: {
        y: -5,
        format:
          '<div style="text-align:center">' +
          `<span style="font-size:36px">${tempValue}</span>` +
          `<span style="font-size:14px;opacity:0.4;margin-left:2px">${unitLabel}</span>` +
          '</div>',
      },
    }, false); // false = don't redraw yet
    chartDP.redraw();
  }
}
